<template lang="html">
  <div class="tabs-bar-wrapper relative z-10 mb-12 mt-6 overflow-auto">
    <fieldset id="segments" class="tabs-bar mx-auto w-full sm:w-max">
      <input
        v-model="segment"
        type="radio"
        value="all"
        name="segments"
        id="segment-all"
        key="0"
        @change="update"
        checked
      />
      <label for="segment-all">Se alle</label>

      <template v-for="(s, key) in segments" :key="key + 1">
        <input
          v-model="segment"
          :id="`segment-${s.slug}`"
          type="radio"
          :value="s.slug"
          name="segments"
          @change="update"
        />
        <label class="" :for="`segment-${s.slug}`">{{ s.name }}</label>
      </template>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: 'FilterSegment',
  props: ['segments'],
  data() {
    return {
      segment: 'all',
    };
  },
  methods: {
    update() {
      this.$emit('segmentUpdated', this.segment);
    },
  },
};
</script>
